export enum TaxRateCalculationType {
  FullAmount = 'full-amount',
  RTOPayment = 'rto-payment',
}
